export const toasts = {
    // GENERAL
    'Invalid response from server': 'Respuesta no válida del servidor',
    // USERS
    'User edited successfully': 'Usuario editado exitosamente'
};
